'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(render$2, outer) {
  this.H0 = null;
  this.H0 = render$2;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
}
export { $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 as $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 };
$p = $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1() {
}
export { $h_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 as $h_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 };
$h_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1.prototype = $p;
$p.Sw = (function(value) {
  return this.H0.j(value);
});
var $d_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1, "com.raquo.laminar.modifiers.RenderableText$$anon$1", ({
  iG: 1,
  iE: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 as $d_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 };
